module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "img-responsive logo-header",
    attrs: {
      "src": "static/img/Logo-EPM2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive logo-header",
    attrs: {
      "src": "static/img/Logo-Emtelco2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive pull-right logo-header",
    attrs: {
      "src": "static/img/Logo2.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d62c58"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-header.vue
// module id = 74
// module chunks = 0